module.exports = __webpack_public_path__ + "img/arrow.e258b3ec.svg";